import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import i18next from 'i18next';
import { useFormContext, Controller } from 'react-hook-form';
import { FormRow } from '@famly/stat_forms_form-row';
import { useDynamicHeight } from '@famly/stat_ts-utils_dynamic-height';
import {} from '@famly/stat_kinder-connect-capture_lib';
export const KinderConnectCaptureComponent = ({ onClose, isDisabled = false, showHeader = false, disableDynamicHeight, config, customHeader, customPhotoCaptureRow, customSignatureCaptureRow, customGeolocationCaptureRow, }) => {
    const { control } = useFormContext();
    const dynamicHeightRef = useDynamicHeight({ baseMaxHeight: '80svh', disabled: disableDynamicHeight });
    return (_jsxs(_Fragment, { children: [showHeader ? _jsx(_Fragment, { children: customHeader }) : null, _jsxs("div", { ref: dynamicHeightRef, children: [customPhotoCaptureRow, customSignatureCaptureRow, customGeolocationCaptureRow] })] }));
};
